import { FC, useEffect, useMemo, useState } from 'react';

import { useLocation } from 'react-router-dom';

import styles from './Ad.module.scss';
import { placingAdOptions } from './data';
import { PagesPathnames } from '../../../../app/types/ad';
import { getCurrentAdPage, isAccessEnded } from '../../../../helpers/utils/functions';
import MainLayout from '../../../../shared/common/components/layouts/MainLayout';
import PageHead from '../../../../shared/common/components/page-header/PageHeader';
import TabSelect from '../../../../shared/common/components/TabSelect/TabSelect';
import { useActions } from '../../../../shared/common/hooks/useActions';
import AddSpend from '../add-spend/AddSpend';
import ConnectAds from '../connect-ads';


const Ad: FC = () => {
    const locationState = useLocation();

    const [ pageMode, setPageMode ] = useState(getCurrentAdPage(locationState.pathname));
    const { setFilters } = useActions();

    useEffect(() => {
        setPageMode(getCurrentAdPage(locationState.pathname));
        setFilters([]);
    }, [ locationState.pathname ]);

    const currentPage = useMemo(() => {
        switch (locationState.pathname){
            case PagesPathnames.manualPlacement: 
                return <AddSpend />;
            case PagesPathnames.autoPlacement:
                return <ConnectAds />;
            default:
                return <></>;
        }
    },[ locationState.pathname ]);


    return (
        <MainLayout pageTitle="Реклама">
            <div className="page-wrapper">
                <PageHead title="Реклама" />

                {isAccessEnded() ? (
                    <iframe
                        className="access-denied-iframe"
                        src={
                            locationState.pathname === PagesPathnames.manualPlacement ?
                                `https://doc.scananalytics.ru/oshibki-i-preduprezhdeniya/dostup-k-otchetu-po-reklame-zakryt/?timestamp=${new Date().getTime()}`
                                :
                                `https://doc.scananalytics.ru/oshibki-i-preduprezhdeniya/dostup-k-otchetu-po-reklame-zakryt/?timestamp=${new Date().getTime()}`
                        }
                    />
                ) : (
                <div className="page-content">

                    <div className={styles.selectWrapper}>
                        <TabSelect options={placingAdOptions}  pageMode={pageMode} setPageMode={setPageMode}>
                        </TabSelect>
                    </div>
                    { currentPage }
                </div>
                )}

            </div>
        </MainLayout>
    );
};

export default Ad;
